import { defineComponent as a, openBlock as r, createBlock as l, unref as p, mergeProps as c, withCtx as m, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const f = /* @__PURE__ */ a({
  name: "IconArrowDownInCircle",
  __name: "IconArrowDownInCircle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (s, n) => (r(), l(p(i), c(t, { "view-box": "0 0 24 24" }), {
      default: m(() => [...n[0] || (n[0] = [
        e("path", { d: "M20.25 12a8.25 8.25 0 1 0-16.5 0 8.25 8.25 0 0 0 16.5 0m1.5 0c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75" }, null, -1),
        e("path", { d: "M11.25 16.243a.75.75 0 0 0 1.5 0V7.757a.75.75 0 0 0-1.5 0v8.486" }, null, -1),
        e("path", { d: "M8.944 12.641a.75.75 0 0 0-1.06 1.06l3.232 3.233a1.25 1.25 0 0 0 1.768 0l3.232-3.232a.75.75 0 1 0-1.06-1.06L12 15.696 8.944 12.64" }, null, -1),
        e("path", { d: "M7.884 13.702a.75.75 0 0 1 1.06-1.06l2.306 2.305v-7.19a.75.75 0 1 1 1.5 0v7.19l2.306-2.306a.75.75 0 1 1 1.06 1.06l-3.232 3.233a1.25 1.25 0 0 1-1.768 0l-3.232-3.232" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
